import React from 'react';
import { ArcStack, ArcText } from '@src/core/ui';

import { ArcOrderProps, ArcOrderVariantProps } from './types';
import { EMPTY_STRING } from '@src/core/config';
import { arcDateWithTime } from '@src/core/extensions';

const ArcOrder: React.FC<ArcOrderProps> & ArcOrderVariantProps = (props) => {
  const { order, children, ...rest } = props;

  return (
    <ArcStack border='0.5px solid'  {...rest}>
      <ArcStack>
        <ArcStack direction='row' justifyContent='space-between'>   
          <ArcText.h6 maxLines={1}> #{order.id} {order.clientName}  </ArcText.h6>
          <ArcText color="text.secondary" fontSize={12} >
            {arcDateWithTime(order.createDate)}
          </ArcText>
        </ArcStack>
        <ArcText.caption maxLines={4} marginTop={1.5}> {order.deliveryLocation.address ?? EMPTY_STRING} </ArcText.caption>
      </ArcStack>
      {children}
    </ArcStack>
  );
};

ArcOrder.primary = ({ selected, sx, ...rest }) => (
  <ArcOrder 
    p='12px' 
    borderRadius={1}
    bgcolor='background.paper' 
    sx={{ cursor: 'pointer', ...sx }}
    borderColor={selected ? 'brand.main' : 'background.paper'}
    {...rest} /> 
);

ArcOrder.secondary = ({ sx, ...rest }) => (
  <ArcOrder 
    p='12px' 
    borderRadius={1} 
    bgcolor='background.default' 
    sx={{ cursor: 'pointer', ...sx }} 
    {...rest} />
);

export default ArcOrder;